// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const StatusChangeRequestForm = t.struct({
    isValid: t.Boolean
});

export const getDefaultState = () => new StatusChangeRequestForm({
    isValid: false
});

export default StatusChangeRequestForm;




// WEBPACK FOOTER //
// ./src/product/status-change-request/state/status-change-request-form.js